<template>
    <div class="test-tab-wrap">
        <TestService
            v-if="!selectedResponse"
            ref="testService"
            :test-response="testResponse"
            :is-loading="isLoading"
            :phrase.sync="phrase"
            :contexts="contexts"
            :selected-context="selectedContext"
            @submit="handlePhraseTest"
            @inspect-response="handleInspectResponse"
        />
        <ResponseInspector
            v-else
            :phrase="testResponse.result.question"
            :response="selectedResponse"
            :entities="selectedResponseEntities"
            :utterances="selectedContextUtterances"
            @close="selectedResponse = null"
        />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { testPhraseValidationMixin } from '@/mixins/test-phrase-validation.mixin'
import TestService from './TestPreview/TestService'
import ResponseInspector from './ResponseInspector/ResponseInspector'

export default {
  components: {
    TestService,
    ResponseInspector
  },

  mixins: [testPhraseValidationMixin],

  data () {
    return {
      isLoading: false,
      phrase: '',
      selectedContext: null,
      selectedResponse: null,
      testResponse: null
    }
  },

  computed: {
    ...mapState('knowledgebase', ['categories', 'allApplications']),

    selectedResponseEntities () {
      if (this.testResponse) {
        return this.testResponse.result.entities || []
      }

      return []
    },

    contextsUtterances () {
      const utterancesByContext = this.categories.value.reduce((acc, context) => {
        acc[context.name] = (context.utterances || []).map(utterance => utterance.text)

        return acc
      }, {})
      utterancesByContext.All = Object.values(utterancesByContext).reduce((acc, curr) => [...acc, ...curr], [])

      return utterancesByContext
    },

    selectedContextUtterances () {
      if (this.selectedResponse) {
        return this.contextsUtterances[this.selectedResponse.context] || []
      }

      return []
    },

    contexts () {
      const modelContexts = _.map(this.allApplications, app => ({
        label: app.name,
        value: app.luisId
      }))

      return [{ label: 'All', value: 'all' }, ...modelContexts]
    }
  },

  methods: {
    ...mapActions('knowledgebase/test', ['testMeaning']),

    handleInspectResponse (response) {
      this.selectedResponse = response
    },

    async handlePhraseTest ({ phrase, context }) {
      this.isLoading = true
      this.testResponse = null

      this.testResponse = await this.testMeaning({
        appId: context,
        q: phrase
      })

      this.phrase = ''
      this.$refs.testService.resetPhraseValidation()
      this.selectedContext = context
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.test-tab-wrap {
    display: flex;
    height: 100%;
}
</style>
